module.exports = __webpack_public_path__ + "media/images/undraw_schedule_re_2vro-ed932646851319f08dd48445a80b3499.svg";